import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const buttonLabelFn = /* @__PURE__ */ createRecipe('button-label', {}, [])

const buttonLabelVariantMap = {}

const buttonLabelVariantKeys = Object.keys(buttonLabelVariantMap)

export const buttonLabel = /* @__PURE__ */ Object.assign(memo(buttonLabelFn.recipeFn), {
  __recipe__: true,
  __name__: 'buttonLabel',
  __getCompoundVariantCss__: buttonLabelFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: buttonLabelVariantKeys,
  variantMap: buttonLabelVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, buttonLabelVariantKeys)
  },
  getVariantProps: buttonLabelFn.getVariantProps,
})